import React, { useMemo } from 'react'
import { Button, Icon, Input } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import type { FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'
import { BeneficiaryDetailsCurrency, PaymentMethods } from 'types/beneficiaries'
import { isIbanFormat } from 'utils/beneficiaries'

type BankCodeFieldProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  formValues: ContactFiatInstrumentFormData
  errors: FieldErrors<ContactFiatInstrumentFormData>
  formFieldLabels: FormFieldLabels
  isLoading: boolean
  isValidBankCode: boolean
  bankCode?: string
  onBlur: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const BankCodeField = ({
  register,
  formValues,
  errors,
  formFieldLabels,
  isLoading,
  isValidBankCode,
  bankCode,
  onBlur,
  onChange,
}: BankCodeFieldProps) => {
  const { paymentMethods, currency } = formValues || {}
  
  const iconButton = useMemo(() => {
    const isGbpSwiftAndLocal = currency === BeneficiaryDetailsCurrency.GBP && paymentMethods?.includes(PaymentMethods.SWIFT) && paymentMethods?.includes(PaymentMethods.FASTER_PAYMENT)
    
    if (isGbpSwiftAndLocal || isLoading) return

    if (isValidBankCode && bankCode) {
      return <Button variant="ghost" iconElement={<Icon name="Check" />} />
    }

  }, [currency, isLoading, isValidBankCode, bankCode, paymentMethods])


  const isDisabled = useMemo(() => {
    if (currency === BeneficiaryDetailsCurrency.GBP) {
      return paymentMethods?.includes(PaymentMethods.SWIFT) && paymentMethods?.includes(PaymentMethods.FASTER_PAYMENT) && isIbanFormat(formValues?.accountNumber)
    }

    return false
  }, [currency, paymentMethods, formValues?.accountNumber])

  return (
    <Input
      {...register('bankCode')}
      name="bankCode"
      testId="bankCode"
      label={formFieldLabels.bankCode}
      placeholder={formFieldLabels?.bankCodePlaceholder}
      errorText={errors?.bankCode?.message}
      error={!!errors?.bankCode?.message}
      loading={isLoading}
      onChange={onChange}
      onBlur={onBlur}
      IconButton={iconButton}
      iconPosition="right"
      disabled={isDisabled}
    />
  )
}

